<template>
    <widget-card
        title="Plots active in this event"
        :loading="loading"
        :error="error"
        :empty="!loading && (!payload || payload.length === 0)"
        :hidden="hidden"
        @retry="fetchData"
    >
        <div v-if="payload && payload.length" class="rows" :class="{ 'is-dark': $vuetify.theme.dark }">
            <div v-for="row in payload" :key="row.plotKeyId" class="row" @click="goToPlot(row.plotKeyId)">
                <span class="name">{{ row.name }}</span>
                <span class="counts">{{ row.encounterCount }} enc · {{ row.lammieCount }} lam</span>
            </div>
        </div>
    </widget-card>
</template>

<script>
import api from '@/api'
import WidgetCard from './WidgetCard.vue'

export default {
    name: 'PlotsActiveWidget',
    components: { WidgetCard },
    props: {
        eventId: { type: Number, default: null },
        mode: { type: String, default: 'mine' },
        refreshKey: { type: Number, default: 0 },
    },
    data() {
        return { loading: false, error: null, payload: null, hidden: false, inFlightKey: null }
    },
    watch: {
        eventId: { handler: 'fetchData', immediate: true },
        mode: 'fetchData',
        refreshKey: 'fetchData',
    },
    methods: {
        endpointUrl() {
            const m = this.mode.charAt(0).toUpperCase() + this.mode.slice(1)
            return `dashboard/plotsActive/${this.eventId}?mode=${m}`
        },
        async fetchData() {
            if (!this.eventId) { this.payload = null; return }
            const key = `${this.eventId}|${this.mode}`
            this.inFlightKey = key
            this.loading = true; this.error = null; this.hidden = false
            try {
                const data = await api.get(this.endpointUrl())
                if (this.inFlightKey !== key) return
                this.payload = data
            } catch (err) {
                if (this.inFlightKey !== key) return
                if (err.response && err.response.status === 403) { this.hidden = true; return }
                this.error = err
            } finally {
                if (this.inFlightKey === key) this.loading = false
            }
        },
        goToPlot(id) {
            this.$router.push({ name: 'readPlot', params: { id } })
        },
    },
}
</script>

<style scoped>
.row { display: flex; justify-content: space-between; padding: 4px 0; cursor: pointer; }
.row:hover { background: rgba(25,118,210,0.04); }
.name { font-weight: 500; }
.counts { color: rgba(0,0,0,0.6); font-size: 11px; }
.rows.is-dark .counts { color: rgba(255,255,255,0.7); }
</style>
